import Chart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'
import { useTranslation } from 'react-i18next'

const VARIANTS = {
  // On the dark analytics card.
  dark: {
    fontFamily: 'Roobert',
    labelColor: '#94A3B8',
    tooltipTheme: 'light',
    axisTicks: false
  },
  light: {
    fontFamily: 'inherit',
    labelColor: '#000000',
    tooltipTheme: 'dark',
    axisTicks: true
  }
}

interface DailyReturnsChartProps {
  values: number[]
  days: string[]
  variant: keyof typeof VARIANTS
  className?: string
}

export function DailyReturnsChart({
  values,
  days,
  variant,
  className
}: DailyReturnsChartProps) {
  const { t, i18n } = useTranslation()
  const style = VARIANTS[variant]

  const options: ApexOptions = {
    chart: {
      animations: {
        speed: 400,
        animateGradually: {
          enabled: false
        }
      },
      fontFamily: style.fontFamily,
      foreColor: '#AEDCFF',
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    colors: ['#AEDCFF'],
    dataLabels: {
      enabled: false
    },
    fill: {
      colors: ['#003096'],
      opacity: 0.5
    },
    grid: {
      show: false,
      padding: {
        bottom: -40,
        left: 0,
        right: -25
      }
    },
    stroke: {
      curve: 'smooth',
      width: 2
    },
    tooltip: {
      theme: style.tooltipTheme,
      y: {
        formatter: (value: number) => value.toLocaleString(i18n.language)
      }
    },
    markers: {
      size: 0
    },
    xaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: style.axisTicks
      },
      categories: days,
      labels: {
        offsetY: -20,
        rotate: 0,
        style: {
          colors: style.labelColor
        }
      },
      tickAmount: 6,
      tooltip: {
        enabled: false
      }
    },
    yaxis: {
      min: 0,
      show: false,
      tickAmount: 5
    }
  }

  const series = [{ name: t('main_chart.returned_items'), data: values }]

  return (
    <Chart
      className={className}
      type="area"
      options={options}
      series={series}
      height="100%"
      width="100%"
    />
  )
}
